import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import style from './style.module.scss';
import Icons from './Icons';
import cx from 'classnames';
import { Tooltip } from '@ontruck/orc';
import Icon from '@ontruck/ontruck-react-components/lib/Icon';
import TemperatureText from './TemperatureText';

const multipleTemperatureIcons = {
  2: <Icon name="bi-temp" className={cx(style.extraIcon, style.multipleTemp)} />,
  3: <Icon name="tri-temp" className={cx(style.extraIcon, style.multipleTemp)} />,
};

const TemperatureIcons = ({ intl, temperature_ranges, t, showTooltip = true }) => {
  return (
    <Fragment>
      {multipleTemperatureIcons[temperature_ranges.length] ? (
        showTooltip ? (
          <Fragment>
            <Tooltip
              component={
                <div>
                  {temperature_ranges.map(({ min, max }, key) => (
                    <div className={style.multipleTemperatureIcons} key={key}>
                      <Icons min={min} max={max} />
                      <TemperatureText min={min} max={max} intl={intl} text={t.temperature} />
                    </div>
                  ))}
                </div>
              }
              position="bottom"
              skin="light"
            >
              {multipleTemperatureIcons[temperature_ranges.length]}
            </Tooltip>
          </Fragment>
        ) : (
          <span className={style.outsideIcons}>
            {multipleTemperatureIcons[temperature_ranges.length]}
            {temperature_ranges.map(({ min, max }) => (
              <span className={style.multipleTemperatureIcons}>
                <Icons min={min} max={max} />
                <TemperatureText min={min} max={max} intl={intl} text={t.temperature} />
              </span>
            ))}
          </span>
        )
      ) : showTooltip ? (
        <Fragment>
          {temperature_ranges.map(({ min, max }, key) => (
            <Fragment key={key}>
              <Icons min={min} max={max} showTooltip={showTooltip} intl={intl} t={t} />
            </Fragment>
          ))}
        </Fragment>
      ) : (
        <span>
          {temperature_ranges.map(({ min, max }, key) => (
            <span key={key}>
              <Icons min={min} max={max} />
              <TemperatureText min={min} max={max} intl={intl} text={t.temperature} />
            </span>
          ))}
        </span>
      )}
    </Fragment>
  );
};

TemperatureIcons.propTypes = {
  temperature_ranges: PropTypes.array,
  t: PropTypes.any,
  showTooltip: PropTypes.bool,
  intl: PropTypes.any,
};

export default TemperatureIcons;
